/**
 * Created by Santiago on 12/6/17.
 */

export default {
    shareScreen: "Vai vēlaties koplietot savu ekrānu?",
    no: "Nē",
    yes: "Jā",
    youmustpickastar: "Lūdzu izvēlieties vienu no vērtējumiem",
    name: "Vārds",
    email: "E-pasts",
    phone: "Telefons",
    message: "Ziņa",
    sendMessage: "Sūtīt ziņu",
    newConversation: "Jauna saruna",
    sendpunctuation: "Nosūtīt atsauksmi",
    musttypemail: "Jums jāievada jūsu e-pasta adrese",
    validemail: "Ievadīta nederīga e-pasta adrese",
    screenshare: "Koplietot ekrānu",
    musttypename: "Jums jāievada jūsu vārds",
    musttypemessage: "Jums jāievada ziņa",
    configuration: "Konfigurācija",
    notifications: "Paziņojumi",
    notificationDetails: "Paziņot par jaunām ziņām šajā sarakstē",
    close: "Aizvērt",
    cancel: "Atcelt",
    save: "Saglabāt",
    willclose: "Tiek aizvērta sarakste",
    closeconf: "Vai tiešām vēlaties aizvērt šo saraksti ?",
    conversationend: "Sarakste ir beigusies, vai vēltaties to aizvērt?",
    newmessage: "Jauna ziņa",
    typehere: "Nosūtīt ziņu...",
    whatdoyouthink: "Kā varat novērtēt saņemto palīdzību ?",
    sendbymail: "Nosūtīt saraksti e-pastā",
    holdtimeavg: "Vidējais gaidīšanas laiks",
    holdtime: "Jūsu gaidīšanas laiks",
    messagesended: "Ziņa nosūtīta!",
    emailerror: "Lūdzu ievadīt derīgu e-pastu, lai turpinātu",
    fieldserror:"Lūdzu pārbaudīt visus aizpildītos laukus un mēģiniet vēlreiz",
    messageserror: "Ups, kaut kas nogāja greizi :(",
    message: "Ievadiet savu ziņu...",
    transfering: "Pārvieno...",
    endchat: "Beigt saraksti",
    videocall: "Videozvans",
    call: "Zvans",
    openinextarnalwindow: "Atvērt atsevišķā logā",
    calling: "Zvana",
    callingduration: "Zvanīšanas ilgums",
    mute: "Izslēgt skaņu",
    allowmicrophone: "Atļaut izmantot mikrofonu",
    hangup: "Beigt zvanu",
    duration: "Ilgums ",
    write: "Rakstīt",
    survey_title: 'Ceram, ka esat apmierināti ar pakalpojumu',
    survey_desc: "Jūsu viedoklis mums ir svarīgs. Vai veltīsiet nedaudz laika, lai atstātu atsauksmi?",
    available: "Pieejams",
    invalidextension: "Pielikuma formāts nav derīgs",
    maxfilesize10mb: "Maksimālais faila lielums 10 MB"
};